import * as Sentry from '@sentry/browser'

interface SentryTrackingData {
  locale: string
  companyId: number
  companyName: string
  companySize: string
  userId: number
}

export default function runSentry({
  locale,
  companyId,
  companyName,
  companySize,
  userId,
}: SentryTrackingData) {
  Sentry.setTag('locale', locale)
  Sentry.setTag('company_id', companyId)
  Sentry.setTag('company_size', companySize)
  Sentry.getCurrentScope().setUser({
    id: String(userId),
    company_id: companyId,
    company_name: companyName,
    locale,
  })
}
